import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { ICooperationRole } from "@umu/umu-types";
export type { ICooperationRole } from "@umu/umu-types";

export const getCooperationRole = (param: {groupId: string | number, teacherId: string}): Promise<IResponse<Record<string, ICooperationRole>>> => {
	return fetchData(Api.GET_COURSE_COOPERATION_ROLE, {
        obj_id: param.groupId,
        obj_type: 'group',
        teacher_ids: param.teacherId
    });
};
